import { partnersQuoteRequest } from 'rails_routes'
import { type QuotingProspect } from 'utils/web_api.schemas'
import { useWindowLocation } from 'utils/windowLocation'

import { type MetadataConfiguration } from '../types'
import { resolveNextStepPath } from '../utils'
import CreateOrUpdateProspect, { type CreateOrUpdateProspectProps, LARGE_GROUP_EMPLOYEE_THRESHOLD } from './CreateOrUpdateProspect'

type Props = Omit<CreateOrUpdateProspectProps, 'onSuccess'> & {
  nextStepPath: string,
  autoImportCensusId?: string,
  metadataConfiguration: MetadataConfiguration
}

export function CreateProspect ({ nextStepPath, autoImportCensusId, ...props }: Props) {
  const { replace } = useWindowLocation()

  const onSuccess = (prospect: QuotingProspect) => {
    // Route large groups (>50 employees) to the quote request flow
    if (prospect.employee_count && prospect.employee_count > LARGE_GROUP_EMPLOYEE_THRESHOLD) {
      replace(partnersQuoteRequest.show({ id: prospect.id }))
      return
    }

    let path = resolveNextStepPath(nextStepPath, prospect.id)
    if (autoImportCensusId) {
      if (path.includes('?')) {
        path += `&census_id=${encodeURIComponent(autoImportCensusId)}`
      } else {
        path += `?census_id=${encodeURIComponent(autoImportCensusId)}`
      }
    }
    replace(path)
  }

  return (
    <div className='flex justify-center'>
      <CreateOrUpdateProspect {...props} autoImportCensusId={autoImportCensusId} onSuccess={onSuccess} />
    </div>
  )
}

export default (props: Props) => {
  return (
    <CreateProspect {...props} />
  )
}
